import React from 'react';

import { SectionHeader } from './section-header';
import {
  Tab,
  TabButton,
  TabButtonProps,
  TabIcon,
  TabIconProps,
  TabLink,
  TabLinkProps,
  TabList,
  TabLogo,
  TabLogoProps,
  TabSection,
  TabText,
} from './tab';

const t = require('views/internal/recup-with-helpers')('home');

type HomeTabProps = TabLinkProps;

const HomeTab: React.StatelessComponent<HomeTabProps> = (props) => (
  <Tab>
    <TabLink {...props}>
      <TabIcon iconName="home" />
      <TabText>{t.l('home')}</TabText>
    </TabLink>
  </Tab>
);

type BoardsTabProps = TabLinkProps;

const BoardsTab: React.StatelessComponent<BoardsTabProps> = (props) => (
  <Tab>
    <TabLink {...props}>
      <TabIcon iconName="board" />
      <TabText>{t.l('boards')}</TabText>
    </TabLink>
  </Tab>
);

interface TeamLinkSubTabProps extends TabLinkProps, TabIconProps {
  linkClass: string;
  displayName: string;
}

const TeamLinkSubTab: React.StatelessComponent<TeamLinkSubTabProps> = ({
  displayName,
  iconName,
  ...props
}) => (
  <Tab>
    <TabLink {...props}>
      <TabIcon iconName={iconName} />
      <TabText>{displayName}</TabText>
    </TabLink>
  </Tab>
);

interface TeamTabProps extends TabLogoProps, TabLinkProps {
  displayName: string;
  linkTabs: TeamLinkSubTabProps[];
  selected: boolean;
}

const TeamTab: React.StatelessComponent<TeamTabProps> = ({
  displayName,
  linkTabs,
  logoUrl1x,
  logoUrl2x,
  selected,
  ...props
}) => (
  <Tab>
    <TabLink selected={selected} {...props}>
      {logoUrl1x && <TabLogo logoUrl1x={logoUrl1x} logoUrl2x={logoUrl2x} />}
      {!logoUrl1x && <TabIcon iconName="organization" />}
      <TabText>{displayName}</TabText>
    </TabLink>
    {selected &&
      !!linkTabs.length && (
        <TabList>
          {linkTabs.map((linkTab) => <TeamLinkSubTab indented {...linkTab} />)}
        </TabList>
      )}
  </Tab>
);

type CreateTeamTabProps = TabButtonProps;

const CreateTeamTab: React.StatelessComponent<CreateTeamTabProps> = (props) => (
  <Tab>
    <TabButton {...props}>
      <TabIcon iconName="add" />
      <TabText>{t.l('home-create-team')}</TabText>
    </TabButton>
  </Tab>
);

interface NavigationProps {
  homeTab: HomeTabProps;
  boardsTab: BoardsTabProps;
  teamTabs: TeamTabProps[];
  createTeamTab: CreateTeamTabProps;
}

export const Navigation: React.StatelessComponent<NavigationProps> = ({
  homeTab,
  boardsTab,
  teamTabs,
  createTeamTab,
  ...props
}) => (
  <nav {...props}>
    <TabSection>
      <TabList>
        <BoardsTab {...boardsTab} />
        <HomeTab {...homeTab} />
      </TabList>
    </TabSection>
    <TabSection>
      <SectionHeader noMargin>{t.l('teams')}</SectionHeader>
      <TabList>
        {teamTabs.map((teamTab) => <TeamTab {...teamTab} />)}
        <CreateTeamTab {...createTeamTab} />
      </TabList>
    </TabSection>
  </nav>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/navigation.tsx